export default {
  description: '{{name}} à {{city}}. Menu officiel. Économisez et commandez en ligne ici.',
};
